module.exports = __webpack_public_path__ + "static/assets/6b1875bc13d5ff30cdedb70ecf412da7.png";